import { gql, useQuery } from '@apollo/client';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { Navigate, Outlet } from 'react-router-dom';
import { ROOT_PATH } from 'src/common/constants';
import { MemberType } from 'src/common/number-enum';
import { getUserInfo } from 'src/graphql/queries';

const AdminRoute = () => {
  const { user } = useAuthenticator((context) => [context.user]);
  const { data, loading: isLoading } = useQuery(gql(getUserInfo), {
    variables: { input: { mu_mail: user?.username || 'no user' } },
  });

  if (isLoading) return <div>Loading...</div>;

  // 管理者権限を持つUserのみ。
  if (data && data.getUserInfo[0].mu_admin_kb === MemberType.ADMIN) {
    return <Outlet />;
  }

  return <Navigate to={ROOT_PATH} />;
};

export default AdminRoute;
